import { photoUrlBase } from 'constants/common';

export const curtainsKinds = [
	{
		text: 'Блэкаут',
		imgUrls: {
			lDesk: `${photoUrlBase}/vV-iOH5N5EegO-LKzPx43A/services-platform-instore-landing-shtori-blackout-l-desk.png`,
			desk: `${photoUrlBase}/waA-xJ01YESUF9jY8BimTw/services-platform-instore-landing-shtori-blackout-desk.png`,
			tab: `${photoUrlBase}/KnoXsUCbdkWrH2XQS_vUVg/services-platform-instore-landing-shtori-blackout-tab.jpg`,
		},
		dataQa: 'blackout-curtains-kind',
		modalButtonText: 'Подробнее',
		modalContentItems: [
			'Шторы блэкаут включают пошив штор из специальной ткани, которая обеспечивает полное затемнение помещения. Такие шторы идеально подходят для спален, гостиных и домашних кинотеатров, так как они не пропускают свет, холод и шум.',
			'Мы предлагаем различные варианты тканей, индивидуальные эскизы и качественную работу.',
		],
		modalTitle: 'Шторы блэкаут',
		modalImgUrl: `${photoUrlBase}/f9ZX-tlexEmDvL1Onvd1zA/services-platform-instore-landing-shtori-blackout-modal.png`,
		modalImgAlt: 'Шторы блэкаут',
	},
	{
		text: 'Светопропускающие',
		imgUrls: {
			lDesk: `${photoUrlBase}/LbZF7g1JSU2G2w8Oi2AfIg/services-platform-instore-landing-shtori-light-transmitting-l-desk.png`,
			desk: `${photoUrlBase}/l2xIlev-k0mM01oaM0q20A/services-platform-instore-landing-shtori-light-transmitting-desk.png`,
			tab: `${photoUrlBase}/qfj0DlTYeEG00GDdH7o89A/services-platform-instore-landing-shtori-light-transmitting-tab.jpg`,
		},
		dataQa: 'light-transmitting-curtains-kind',
		modalButtonText: 'Подробнее',
		modalContentItems: [
			'Включают изготовление рулонных штор из специальных тканей, которые пропускают солнечный свет, но при этом защищают помещение от перегрева и выгорания мебели и отделки.',
			'Такие шторы идеально подходят для использования на балконах, кухнях, гостиных и спальнях, так как они позволяют регулировать уровень освещённости и обеспечивают комфортный микроклимат в помещении.',
		],
		modalTitle: 'Светопропускающие шторы',
		modalImgUrl: `${photoUrlBase}/h3RtddkzaU6LG_8jEgztww/services-platform-instore-landing-shtori-light-transmitting-modal.png`,
		modalImgAlt: 'Светопропускающие шторы',
	},
	{
		text: 'На люверсах',
		imgUrls: {
			lDesk: `${photoUrlBase}/MzPzMmrmpUCnB8H63jwlHA/services-platform-instore-landing-shtori-on-eyelets-l-desk.png`,
			desk: `${photoUrlBase}/NxhgaD-qT0CfyoVbt9ny0g/services-platform-instore-landing-shtori-on-eyelets-desk.png`,
			tab: `${photoUrlBase}/0umT-KZvS0ywrEJ8nmoX0A/services-platform-instore-landing-shtori-on-eyelets-tab.jpg`,
		},
		dataQa: 'on-eyelets-curtains-kind',
		modalButtonText: 'Подробнее',
		modalContentItems: [
			'Шторы на люверсах включают создание и установку штор с использованием специальных колец — люверсов. Люверсы обеспечивают лёгкое скольжение штор по карнизу и удобство в использовании.',
			'При заказе услуги вы можете выбрать ткань, цвет и размер люверсов, а также определиться с дизайном и стилем штор.',
		],
		modalTitle: 'Шторы на люверсах',
		modalImgUrl: `${photoUrlBase}/G-NlAHAdWUSt689uPV6E4A/services-platform-instore-landing-shtori-on-eyelets-modal.png`,
		modalImgAlt: 'Шторы на люверсах',
	},
	{
		text: 'Римские',
		imgUrls: {
			lDesk: `${photoUrlBase}/ixA_lGMzcECWZJuj9ON5iA/services-platform-instore-landing-shtori-roman-l-desk.png`,
			desk: `${photoUrlBase}/ki8MOVTv-065ofIw_e2oDA/services-platform-instore-landing-shtori-roman-desk.png`,
			tab: `${photoUrlBase}/4W5dbPSGkE-fENFJAYiNxw/services-platform-instore-landing-shtori-roman-tab.jpg`,
		},
		dataQa: 'roman-curtains-kind',
		modalButtonText: 'Подробнее',
		modalContentItems: [
			'Римские шторы — это вертикальные тканевые полотна, которые поднимаются и опускаются с помощью специального механизма. Они отличаются от обычных штор тем, что движутся вертикально и выглядят как сплошное полотно.',
			'Римские шторы состоят из полотна, стержней, колец для шнуров и подъёмного карниза. Они подходят для разных интерьеров и удобны в использовании.',
		],
		modalTitle: 'Римские шторы',
		modalImgUrl: `${photoUrlBase}/IViuroJ7mEuWyTTmBStZgA/services-platform-instore-landing-shtori-roman-modal.png`,
		modalImgAlt: 'Римские шторы',
	},
	{
		text: 'Для коттеджей',
		imgUrls: {
			lDesk: `${photoUrlBase}/1TSZinkx1EOzw_jqFLXz0g/services-platform-instore-landing-for-cottages-l-desk.png`,
			desk: `${photoUrlBase}/gNcxiX_HDE2ujMYwwTISQA/services-platform-instore-landing-for-cottages-desk.png`,
			tab: `${photoUrlBase}/J4P0b5lm4kywxqvAbCQ1Xw/services-platform-instore-landing-for-cottages-tab.jpg`,
		},
		dataQa: 'for-cottages-curtains-kind',
		modalButtonText: 'Подробнее',
		modalContentItems: [
			'Шторы в коттедже должны обеспечивать защиту от света, быть стильными и подходить к интерьеру. Варианты штор: портьеры, тюль, римские, рулонные и плиссированные шторы из разных материалов и с разнообразными рисунками. Мы учитываем размер и форму окон, стиль интерьера.',
		],
		modalTitle: 'Шторы для коттеджей',
		modalImgUrl: `${photoUrlBase}/1mILtCOAh0aK-AHFurXYjg/services-platform-instore-landing-for-cottages-modal.png`,
		modalImgAlt: 'Шторы для коттеджей',
	},
	{
		text: 'Тюли',
		imgUrls: {
			lDesk: `${photoUrlBase}/n4uqpN153U-RFNtzqXNvIA/services-platform-instore-landing-tulle-l-desk.png`,
			desk: `${photoUrlBase}/9YtpJCxUKESeoSO_i8O0Hw/services-platform-instore-landing-tulle-desk.png`,
			tab: `${photoUrlBase}/YgaYTl0EGEC8YCaXUPdKJQ/services-platform-instore-landing-tulle-tab.jpg`,
		},
		dataQa: 'tulle-curtains-kind',
		modalButtonText: 'Подробнее',
		modalContentItems: [
			'Индивидуальный пошив тюлевых штор для вашего дома или офиса. Такая услуга позволяет создать уникальные и оригинальные изделия, которые идеально впишутся в интерьер и подчеркнут его особенность.',
		],
		modalTitle: 'Тюли',
		modalImgUrl: `${photoUrlBase}/fZYRXlInOEu7jPOzURwlVQ/services-platform-instore-landing-tulle-modal.png`,
		modalImgAlt: 'Тюли',
	},
];
